<template lang="pug">
  div
    slot(name='default',
      v-bind:holder='holder',
      v-bind:innerContainer='localContainer',
      v-bind:outerContainer='outerContainer')

</template>
<script>
import Holder from '@edit/render/holder.js';
import FreezedContainer from '@edit/render/freezedcontainer.js';

export default {
  props: {
    transform:{
      type:Object,
      required:true
    },
    parentContainer:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    context:{
      type:Object,
      default() {
        return {}
      }
    }
  },
  data() {
    const sceneObjects = {};
    const container = new PIXI.Container();
    const holder2 = new Holder(this.renderTools, this.parentContainer, container, this.transform, this.updateSceneObjects.bind(this), {}, this.context);
    const holder = Object.freeze({
      update: () => {
        holder2.update()
      },
      enter: () => {
        holder2.enter();
      },
      exit: () => {
        holder2.exit();
      },
      getLocalContainer() {
        return holder2.localContainer;
      },
      getContainer() {
        return holder2.container;
      },
      getParentContainer() {
        return holder2.parentContainer;
      },
      getLocalPointInParent: (p) => {
        return holder2.getLocalPointInParent(p);
      },
      getGlobalPointInParent: (p) => {
        return holder2.getGlobalPointInParent(p);
      },
      getLocalPoint: (p) => {
        return holder2.getLocalPoint(p);
      },
      getGlobalPoint: (p) => {
        return holder2.getGlobalPoint(p);
      },
      events: () => {
        return holder2._events;
      },
      enableInteractive() {
        holder2.enableInteractive();
      },
      addSceneObject: (id, sceneObject) => {
        this.addSceneObject(id, sceneObject);
      },
      removeSceneObject: (id, sceneObject) => {
        this.removeSceneObject(id, sceneObject);
      },
      updateSceneObjects: () => {
        this.updateSceneObjects();
      },
      alignCenter: () => {
        holder2.alignCenter();
      },
      alignTop: () => {
        holder2.alignTop();
      },
      alignBottom: () => {
        holder2.alignBottom();
      },
      alignMiddle: () => {
        holder2.alignMiddle();
      },
      alignLeft: () => {
        holder2.alignLeft();
      },
      alignRight: () => {
        holder2.alignRight();
      },
      scaleCover: () => {
        holder2.scaleCover();
      },
      scaleContain: () => {
        holder2.scaleContain();
      },
      scaleOriginal: () => {
        holder2.scaleOriginal();
      },
      setDisabled: (lol) => {
        holder2.setDisabled(lol);
      }

    });
    //const localContainer = new FreezedContainer(holder2.localContainer);
    //const outerContainer = new FreezedContainer(holder2.container);
    return {
      //holder:Object.freeze(holder)
      holder,
      sceneObjects
    }
  },
  methods: {
    setDisabled(disabled) {
      this.holder.setDisabled(disabled);
      this.renderTools.addToUpdateBatch(this.holder);
    },
    addSceneObject(id, sceneObject) {
      this.sceneObjects[id] = sceneObject;
    },
    removeSceneObject(id, sceneObject) {
      delete this.sceneObjects[id];
    },
    updateSceneObjects() {
      Object.values(this.sceneObjects).forEach( (so) => {
        so.update();
      });
    }
  },
  created() {
    this.localContainer = Object.freeze(new FreezedContainer(this.holder.getLocalContainer()));
    this.outerContainer = Object.freeze(new FreezedContainer(this.holder.getContainer()));
  },
  mounted() {
    this.renderTools.addToEnterBatch(this.holder);
    this.renderTools.addToUpdateBatch(this.holder);
  },
  beforeDestroy() {
    this.renderTools.addToExitBatch(this.holder);
  }
}
</script>
